// Http request
import axios from 'axios'
import Vue from 'vue'
import router from '../router'
// import App from '../App.vue'
import _ from 'lodash'

// let requestList = []
// let cancelToken = axios.CancelToken;
// let removeRequest = (config) => {
//     for(let req in requestList){
//         if(requestList[req].req_id === config.url + '&' + config.method){
//             requestList[req].cancel();
//             requestList.splice(req, 1);
//         }
//     }
// }

axios.defaults.timeout = 3 * 60 * 1000

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // Vue.toasted.global.pop_info('请求之前');
  // let user = JSON.parse(window.localStorage.getItem("user"));
  // console.log('user-------',user);
  // if(user&&user.token&&config.url!='/api/v2/login/'){
  //     config.headers.common['Authorization'] = 'TOKEN ' + user.token;
  // }
  // removeRequest(config);
  // config.cancelToken = new cancelToken((cancel)=>{
  //     requestList.push({ req_id: config.url + '&' + config.method, cancel: cancel });
  // });

  config.headers['Access-Control-Allow-Origin'] = '*'
  // console.log('config-------',config);
  return config
}, function (error) {
  // console.log('error-------',error);
  // Do something with request error
  // Vue.toasted.global.pop_error('请求失败');
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  // Vue.toasted.global.pop_info('响应之前');
  // console.log('response-----------',response);
  // console.log('interceptors  23333333333333',response);
  // removeRequest(response.config);

  return response.data
}, _.debounce((error) => {
  // Do something with response error
  // console.log('error-----------6666',error);
  // if(error.response.status === 401){

  //   // window.localStorage.removeItem('user');
  //   router.push('/login');
  // }
  // Vue.toasted.global.pop_error('响应失败' + error);
  if (error.response.status === 601) {
    Vue.toasted.global.pop_error('请登录~')
    router.push('/login')
  } else if (error.response.status === 602) {
    Vue.toasted.global.pop_error('无权限~')
  }
  return Promise.reject(error)
}, 5000, { 'leading': true, 'trailing': false }))
export default axios
